var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5603V17.7494C2 18.3888 2.23117 18.9688 2.60234 19.4312L8.96156 14.3619L2 8.5603Z",
    fill: "#D0D5DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3971 19.4312C21.7682 18.9682 21.9994 18.3888 21.9994 17.7494V8.5603L15.0379 14.3619L21.3971 19.4312Z",
    fill: "#D0D5DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1598 14.1825L2 8.5603L8.96156 14.3619L10.1592 15.3601C11.2674 16.2189 12.7315 16.2189 13.8397 15.3601L15.0373 14.3619L21.9988 8.5603L13.8391 14.1825C12.7309 14.946 11.2668 14.946 10.1586 14.1825H10.1598Z",
    fill: "#AFB7C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8397 15.3603C12.7315 16.2191 11.2674 16.2191 10.1592 15.3603L8.96157 14.3621L2.60234 19.4313C3.09762 20.049 3.84936 20.4519 4.70228 20.4519H19.2966C20.1501 20.4519 20.9012 20.0484 21.3965 19.4313L15.0373 14.3621L13.8397 15.3603Z",
    fill: "#E5E9EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2966 4.7771H15.1137L12.3991 7.49173C12.1785 7.71231 11.8215 7.71231 11.6009 7.49173L8.88627 4.7771H4.70287C3.20997 4.7771 2 5.98706 2 7.47996V8.56111L10.1598 14.1833C11.268 14.9468 12.732 14.9468 13.8402 14.1833L22 8.56111V7.47996C22 5.98706 20.7894 4.7771 19.2966 4.7771Z",
    fill: "#E5E9EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3991 7.49162L15.1137 4.77699L16.0878 3.8029C16.2713 3.61938 16.1414 3.30586 15.8819 3.30586H14.0779C13.8985 3.30586 13.7538 3.16057 13.7538 2.98116V1.07533C13.7538 0.922986 13.6303 0.800049 13.4785 0.800049H10.5209C10.3692 0.800049 10.2456 0.922986 10.2456 1.07533V2.98116C10.2456 3.16057 10.1004 3.30586 9.92154 3.30586H8.11747C7.85807 3.30586 7.72807 3.61938 7.9116 3.8029L8.88568 4.77699L11.6003 7.49162C11.8209 7.7122 12.1779 7.7122 12.3985 7.49162H12.3991Z",
    fill: "#1E6EF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.af17cabd02d3fd419151d2db16ce8a95.svg";
export { ForwardRef as ReactComponent };